import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import LoitLogo from 'assets/icons/loit-logo.svg';

const StyledLogo = styled.img`
  width: 106px;
  height: 30px;
`;

/*
  ## LOGO LOIT FGTS ##
*/

const Logo = ({ path }) => (
  <Link to={path}>
    <StyledLogo
      src={LoitLogo}
      alt="LOIT FGTS"
      title="LOIT FGTS"
    />
  </Link>
);

Logo.defaultProps = {
  path: '/',
};

Logo.propTypes = {
  path: PropTypes.string,
};

export default Logo;
